// extracted by mini-css-extract-plugin
export default {"locationTable":"Parking_locationTable__SWZ7N"};